import { render, staticRenderFns } from "./AccidentLocation.vue?vue&type=template&id=4b355c86&scoped=true"
import script from "./AccidentLocation.vue?vue&type=script&lang=js"
export * from "./AccidentLocation.vue?vue&type=script&lang=js"
import style0 from "./AccidentLocation.vue?vue&type=style&index=0&id=4b355c86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b355c86",
  null
  
)

export default component.exports